import(/* webpackMode: "eager" */ "/vercel/path0/app/tufte.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/toc.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/tufte-charts.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
